/**
 * @Author: wuyang
 * @Date: 2024/1/11
 * @Description: ""
 */

import { IModalFeatureList, IModelSpellList } from '@/types/task'
import { requestInstance } from './instance'
import { EBizPhone } from '@/types/bizPhone'

/**
 * 查询用户任务列表
 * @param type
 */
export const getTaskList = ({ type }: { type: EBizPhone }) => {
	return requestInstance.get<any, any>(`/task/photo/listByType/${type}`, {})
}
/* 查询ai模型 任务*/
export const getAiModelTaskList = ({ }) => {
	return requestInstance.get<any, any>(`/dialogue/task/list`, {}).fire()
}
/**
 * 获取模型人物对话记录
 */
export const getAiText = (id: any) => {
	return requestInstance.get<any, any>(`dialogue/task/getDialogueTask/${id}`, {}).fire()
}
/* 智能填写提示词 */
export const getAiTextTip = (data: any) => {
	return requestInstance.post<any, any>(`dialogue/image/information/prompt`, data).fire()
}
/* 上传参考图 */
export const uploadDialogueImage = (data: any) => {
	return requestInstance.upload<any, any>(`dialogue/information/upload`, data).fire()
}
/* 获取上传图片和收藏图片 1上传 2 收藏*/
export const getUploadAndCollectImage = (data: any) => {
	return requestInstance.post<any, any>(`dialogue/information/query_source_image`, data).fire()
}
/* 根据模型id获取 配置信息 */
export const getAiModelConfig = (modelId: any) => {
	return requestInstance.get<any, any>(`ai/model/config/${modelId}`, {}).fire()
}
/* 发送会话 */
export const sendAiText = (data: any) => {
	return requestInstance.post<any, any>(`dialogue/image/information/dialogue`, data).fire()
}
/* ai模型对话图片收藏状态修改 */
export const updateAiImageCollect = (data: any) => {
	return requestInstance.post<any, any>(`dialogue/image/information/toggle-collection`, data).fire()
}
/* 积分消耗情况 */
export const getAiImageIntegral = (data: any) => {
	return requestInstance.post<any, any>(`admin/task-score-config/calculate`, data).fire()
}
/* 删除任务 */
export const deleteAiTask = (dialogueTaskId: any) => {
	return requestInstance.del<any, any>(`/dialogue/task/delete/${dialogueTaskId}`, {}).fire()
}

/**
 * 创建任务
 * @param originalUrl
 * @param referedTaskId
 * @param type
 */
export const createTask = ({
	originalUrl,
	referedTaskId,
	type
}: {
	originalUrl?: string
	referedTaskId?: string
	type: any
}) => {
	return requestInstance
		.post<any, { taskId: string; type: number }>('/task/photo/add', {
			originalUrl,
			referedTaskId,
			type
		})
		.fire()
}

/**
 * 复制创意
 * @param originalUrl
 * @param referedTaskId
 * @param type
 */
export const copyTask = ({
	originalUrl,
	taskId,
	referedTaskOrdinalId,
	type,
	seed
}: {
	originalUrl: string
	taskId: string
	referedTaskOrdinalId: string
	type: EBizPhone
	seed: number
}) => {
	return requestInstance
		.post<any, { taskId: string }>('/task/photo/copyTask', {
			originalUrl,
			taskId: taskId,
			referedTaskOrdinalId: referedTaskOrdinalId,
			type,
			seed
		})
		.fire()
}

/**
 * 再次编辑
 * @param originalUrl
 * @param taskId
 * @param referedTaskOrdinalId
 * @param type
 */
export const editAgainTask = ({
	originalUrl,
	taskId,
	referedTaskOrdinalId,
	type
}: {
	repair: any
	originalUrl: string
	taskId: string
	referedTaskOrdinalId: string
	type: EBizPhone
}) => {
	return requestInstance
		.post<any, { taskId: string }>('/task/photo/editAgain', {
			originalUrl,
			taskId: taskId,
			referedTaskOrdinalId: referedTaskOrdinalId,
			type
		})
		.fire()
}

/**
 * 再次执行
 * @param originalUrl
 * @param taskId
 * @param referedTaskOrdinalId
 * @param type
 */
export const execAgainTask = ({
	originalUrl,
	taskId,
	referedTaskOrdinalId,
	type
}: {
	repair: any
	originalUrl: string
	taskId: string
	referedTaskOrdinalId: string
	type: EBizPhone
}) => {
	return requestInstance
		.post<any, any>('/task/photo/execAgain', {
			originalUrl,
			taskId: taskId,
			referedTaskOrdinalId: referedTaskOrdinalId,
			type
		})
		.fire()
}

export const executeTask = (data: any) => {
	return requestInstance.post<any, any>('/task/photo/execute', data).fire()
}

/**
 * 给任务更新图片
 * @param originalUrl
 * @param taskId
 */
export const updateOriginalUrlTask = ({
	originalUrl,
	taskId
}: {
	originalUrl: string
	taskId: string
}) => {
	return requestInstance
		.post<any, any>('/task/photo', {
			originalUrl,
			taskId
		})
		.fire()
}

/**
 * 获取任务切割信息
 * @param taskId
 */
export const getTaskSeg = (taskId: string) => {
	return requestInstance.get<any, { segData: string; taskId: number }>(
		`/task/photo/seg/${taskId}`,
		{}
	)
}

/**
 * 获取任务详情
 * @param taskId
 */
export const getTask = (taskId: string) => {
	return requestInstance.get<any, any>(`/task/photo/getInfo/${taskId}`, {})
}

/**
 * 修改任务名称
 * @param type
 * @param taskId
 * @param taskName
 */
export const updateTaskName = ({
	type,
	taskId,
	taskName
}: {
	taskId: string
	taskName: string
	type: EBizPhone
}) => {
	return requestInstance
		.post<any, any>('/task/photo/updateTaskName', {
			taskId: taskId,
			taskName,
			type
		})
		.fire()
}

/**
 * 删除任务
 * @param taskIds
 */
export const deleteTask = (taskIds: string[]) => {
	return requestInstance
		.del<any, any>(`/task/photo/${taskIds.join(',')}`, {})
		.fire()
}

/**
 * 获取快捷模板中筛选的信息列表
 * @param pageNum
 * @param pageSize
 */
export const getShortCutRecommendList = ({
	pageNum,
	pageSize,
	type
}: {
	pageNum: number
	pageSize: number
	type: any
}) => {
	return requestInstance
		.get<
			any,
			{
				total: number
				data: { prompt: string; id: number }[]
			}
		>(`/short-cut/recom/listByFresh`, {
			pageNum,
			pageSize,
			type
		})
		.fire()
}

/**
 * 获取预设模板中的模特选择器相关信息
 */
export const getPresetModelCategory = () => {
	return requestInstance.get<any, { key: string; value: string[] }[]>(
		`/character/model/list/category`,
		{}
	)
}

/**
 * 根据预设模版中的模特信息查询很多模特图片 模特头像
 * @param age
 * @param gender
 * @param skin
 */
export const getPresetModelList = ({
	pageNum,
	pageSize,
	params
}: {
	pageNum: number
	pageSize: number
	params: Array<{ key: string; value: string }>
}) => {
	const filters = Object.fromEntries((params || []).map((p) => [p.key, p.value]))
	return requestInstance
		.get<any, any>(`/character/model/list`, {
			pageNum,
			pageSize,
			...filters
		})
		.fire()
}

/**
 * 获取预设模板中的场景选择器相关信息
 */
export const getPresetSceneCategory = () => {
	return requestInstance.get<any, string[]>(`/scen/realHuman/list/category`, {})
}

/**
 * 获取预设模板中根据场景类型获取很多场景图片
 */
export const getPresetSceneList = ({
	largeCategory,
	pageNum,
	pageSize
}: {
	largeCategory: string
	pageNum: number
	pageSize: number
}) => {
	return requestInstance
		.get<any, any>(`/scen/realHuman/listByFresh`, {
			largeCategory,
			pageNum,
			pageSize
		})
		.fire()
}

/**
 * 获取商品类型的预设信息
 */
export const getPresetGoodsCategory = () => {
	return requestInstance.get<any, { image: string; category: string }[]>(
		`/scen/goods/list/category`,
		{}
	)
}

/**
 * 根据场景信息查询当前信息所在的page 页数
 * @param pageSize
 * @param prompt
 */
export const getPresetScenePageInfo = ({
	pageSize,
	prompt,
	categoryLarge,
	id
}: {
	categoryLarge: string
	pageSize: number
	prompt: string
	id: any
}) => {
	return requestInstance
		.get<any, any>(`/scen/realHuman/pageNum`, {
			categoryLarge,
			id,
			pageSize,
			prompt
		})
		.fire()
}

/**
 * 根据模特信息查询当前信息所在的page 页数
 * @param pageSize
 * @param prompt
 */
export const getPresetModelPageInfo = (data: {
	pageSize: number
	prompt: string
	id: string
	params: Array<{ key: string; value: string }>
}) => {
	return requestInstance.get<any, any>(`/character/model/pageNum`, data).fire()
}

/**
 * 根据商品信息查询当前信息所在的page 页数
 * @param pageSize
 * @param prompt
 */
export const getPresetGoodsPageInfo = ({
	pageSize,
	category,
	prompt,
	id
}: {
	category: string
	pageSize: number
	prompt: string
	id: string
}) => {
	return requestInstance
		.get<any, any>(`/scen/goods/pageNum`, {
			pageSize,
			category,
			prompt,
			id
		})
		.fire()
}

/**
 * 获取商品类型的根据预设信息获取很多商品图片
 */
export const getPresetGoodsList = ({
	catetory,
	pageNum,
	pageSize
}: {
	catetory: string
	pageNum: number
	pageSize: number
}) => {
	return requestInstance
		.get<any, any>(`/scen/goods/listByCategory`, {
			catetory,
			pageNum,
			pageSize
		})
		.fire()
}

/**
 * 保存自定义面部特征图片
 * source: 增加的图片来源 0 为本地 1 为历史
 * @param imgUrl
 * @param taskId
 * @param source
 */
export const addCharacter = ({
	imgUrl,
	taskId,
	source
}: {
	imgUrl: string
	taskId: string
	source: number
}) => {
	return requestInstance
		.post<any, { characterId: string; imgUrl?: any; source: number }>(
			'/defined/character/add',
			{
				source,
				imgUrl,
				taskId // 在此处添加页面类别
			}
		)
		.fire()
}

/**
 * 获取自定义面部特征图片
 * @param taskId
 */
export const getCharacterByTaskId = (taskId: string) => {
	return requestInstance
		.get<any, any>(`/defined/character/info/${taskId}`, {})
		.fire()
}

/**
 * 删除自定义面部特征图片
 * @param taskId
 */
export const delCharacterByTaskId = (taskId: string) => {
	return requestInstance
		.post<any, any>(`/defined/character/remove/${taskId}`, {})
		.fire()
}

/**
 * 模特咒语词典
 */

export const getModelSpellList = () => {
	return requestInstance
		.get<
			any,
			{
				data: IModelSpellList[]
				total: number
			}
		>(`/model/character/dic/listAll`, {})
		.fire()
}

/** 商品咒语词典 */
export const getGoodsSpellList = () => {
	return requestInstance
		.get<
			any,
			{
				data: IModelSpellList[]
				total: number
			}
		>(`/goods/dic/listAll`, {})
		.fire()
}

/** 模特特征可选项 */
export const getModalFeatureList = () => {
	return requestInstance
		.get<
			any,
			{
				data: IModalFeatureList[]
				total: number
			}
		>(`/character/control/listAll`, {})
		.fire()
}
/* 图片反馈 */
export const imageFeedback = (data: any) => {
	return requestInstance
		.post<any, any>(
			'/system/comment',
			data
		)
		.fire()
}
/* 查询历史上传面部自定义特征 */
export const getCharacterList = (userId: string, pageNum: any) => {
	return requestInstance
		.get(`/system/history/list`, { userId: userId, pageNum: pageNum })
		.fire()
}
/* 删除历史上传面部自定义特征 */
export const delCharacterByHistoryId = (historyId: string) => {
	return requestInstance.del(`/system/history/${historyId}`, {}).fire()
}
/**
 *  查询管理后台配置的文生图风格列表
 */
export const getTextToImgStyleList = (data: any) => {
	return requestInstance
		.get(`/front/material/style/page`, data)
		.fire()
}
/**
 *  查询管理后台配置的文生图风格分类列表
 */
export const getTextToImgStyleCategoryList = (data: any) => {
	return requestInstance
		.get('/material/style/category/page', data)
		.fire()
}
/**
 *  查询文生图风格收藏列表
 */
export const getFavoriteStyleList = (data: any) => {
	return requestInstance
		.get(`/front/material/style/favorites`, data)
		.fire()
}
/**
 *  查询用户最近7天使用文生图风格列表
 */
export const getRecentStyleList = (data: any) => {
	return requestInstance
		.get('/front/material/style/recent', data)
		.fire()
}
/**
 *  文生图风格添加收藏
 */
export const addStyleFavorite = (data: any) => {
	return requestInstance
		.post(`/material/style/favorite`, data)
		.fire()
}
/**
 *  文生图风格取消收藏
 */
export const delStyleFavorite = (id: any) => {
	return requestInstance
		.del(`/material/style/favorite/${id}`, {})
		.fire()
}

/**
 *  查询管理后台配置的动漫IP列表
 */
export const getFashIpList = (data: any) => {
	return requestInstance
		.get(`/front/material/ip/page`, data)
		.fire()
}
/**
 *  查询管理后台配置的动漫IP分类列表
 */
export const getFashIpCategoryList = (data: any) => {
	return requestInstance
		.get('/material/ip/category/page', data)
		.fire()
}
/**
 *  查询用户最近7天使用动漫IP列表
 */
export const getRecentIpList = (data: any) => {
	return requestInstance
		.get('/front/material/ip/recent', data)
		.fire()
}
/**
 *  查询动漫IP收藏列表
 */
export const getFavoriteIpList = (data: any) => {
	return requestInstance
		.get(`/front/material/ip/favorites`, data)
		.fire()
}
/**
 *  动漫IP添加收藏
 */
export const addIpFavorite = (data: any) => {
	return requestInstance
		.post(`/material/ip/favorite`, data)
		.fire()
}
/**
 *  动漫IP取消收藏
 */
export const delIpFavorite = (id: any) => {
	return requestInstance
		.del(`/material/ip/favorite/${id}`, {})
		.fire()
}

/**
 *  查询参考风格列表
 */
export const getCommonStyleList = (type: number, pageNum: number, pageSize: number) => {
	return requestInstance
		.get(`/image/style/byPage`, { type: type, pageSize: pageSize, pageNum: pageNum })
		.fire()
}
/**
 * 查询自定义风格
 */
export const getCustomStyleList = (type: number, pageNum: number, pageSize: number) => {
	return requestInstance
		.get(`/image/custom/byPage`, { type: type, pageSize: pageSize, pageNum: pageNum })
		.fire()
}

/**
 *  新增自定义风格
 * @param file
 */
export const addCustomStyleList = (file: File, type: string) => {
	return requestInstance
		.upload<
			any,
			{
				url: string
			}
		>(`/image/custom/add`, { file, type })
		.fire()
}

/**
 *  删除自定义风格
 */
export const delCustomStyleList = (id: string, imgUrl: string, thumbnailImgUrl: string) => {
	return requestInstance
		.post(`/image/custom/delete`, { id, imgUrl, thumbnailImgUrl })
		.fire()
}

/**
 *  查询历史记录
 */
export const getHistoryList = (pageNum: number, pageSize: number, types: any) => {
	const typesStr = Array.isArray(types) ? types.join(',') : types;
	return requestInstance
		.get(`/task/photo/getHistory`, { pageSize, pageNum, types: typesStr })
		.fire()
}
/**
 *  查询我的收藏列表
 */

export const getMyCollection = (pageNum: number, pageSize: number, types: any) => {
	const typesStr = Array.isArray(types) ? types.join(',') : types;
	return requestInstance
		.get(`/task/photo/listByType`, { pageSize, pageNum, types: typesStr })
		.fire()
}
/**
 *  查询上传过的图片列表
 */

export const getHistoryImage = (pageNum: number, pageSize: number, types: any) => {
	const typesStr = Array.isArray(types) ? types.join(',') : types;
	return requestInstance
		.get(`/task/photo/getHistoryImage`, { pageSize, pageNum, types: typesStr })
		.fire()
}
/**
 *  任务重新生成
 */

export const taskExecAgain = (originalUrl: string, taskId: string, referedTaskOrdinalId: string, type: string) => {
	return requestInstance
		.post('/task/photo/execAgain', { originalUrl, taskId, referedTaskOrdinalId, type })
		.fire()
}
/**
 *  任务再次编辑
 */

export const taskEditAgain = (originalUrl: string, referedTaskOrdinalId: string, taskId: string, type: string) => {
	return requestInstance
		.post('/task/photo/editAgain', { originalUrl, referedTaskOrdinalId, taskId, type })
		.fire()
}

/**
 *  删除参考图
 */
export const deleteReferenceFile = (objectKeys: any) => {
	return requestInstance
		.post(`/oss/file/deleteFile`, { objectKeys })
		.fire()
}
/**
 *  删除传过的图
 */
export const deleteHistoryImage = (originImgUrl: string, taskId: string, taskOrdinalId: string) => {
	return requestInstance
		.post('/task/photo/deleteHistoryImage', { originImgUrl, taskId, taskOrdinalId })
		.fire()
}
/**
 *  智能联想
 *  @param description
 */
export const getAssociation = (description: string, type: string) => {
	return requestInstance
		.get('/image/style/association', { description, type })
		.fire()
}
/**
 *   识图转文
 *  @param url
 */
export const imageIntoText = (url: string, type: string) => {
	return requestInstance
		.get('/image/style/readPicture', { url, type })
		.fire()
}
/**
 *  根据types 查询最新的任务数据
 */
export const getNewestTaskResult = (types: any) => {
	const typesStr = Array.isArray(types) ? types.join(',') : types;
	return requestInstance
		.get(`/task/photo/getTaskResult`, { types: typesStr })
		.fire()
}
/**
 *  查询批次列表
 */
export const getBatchList = (data: any) => {
	return requestInstance
		.get(`/batch/list`, data)
		.fire()
}
/**
 *  新建批次信息
 */
export const addBatch = (data: any) => {
	return requestInstance
		.upload(`/batch/add`, data)
		//.post(`/batch/add`, data)
		.fire()
}
/**
 *  详情页新建批次信息
 */
export const addBatchDetailPage = (data: any) => {
	return requestInstance
		.post(`/batch/batch-add`, data)
		//.post(`/batch/add`, data)
		.fire()
}
/**
 * 删除批次信息
 * @param batchId
 */
export const deleteBatch = (batchId: string) => {
	return requestInstance
		.del<any, any>(`/batch/delete/${batchId}`, {})
		.fire()
}
/* 
*任务软删除
 * @param batchId
 */
export const softDeleteTask = (taskId: string) => {
	return requestInstance
		.del<any, any>(`/batch/softDelete/${taskId}`, {})
		.fire()
}
export const stopBatch = (batchId: string) => {
	return requestInstance
		.post<any, any>(`/batch/stop/${batchId}`, {})
		.fire()
}
/**
 * 查询批次详情
 * @param batchId
 */
export const getBatchDetail = (batchId: string, params?: any) => {
	return requestInstance
		.get(`/batch/getOne/${batchId}`, params || {})
		.fire()
}
/**
 * 分页查询批次详情(适用于文生图和相似图裂变详情等)
 */
export const getOnePage = (data: any) => {
	return requestInstance
		.get(`/batch/getOnePage/list`, data)
		.fire()
}
// export const getOnePage = (batchId: string, pageNum?: number, pageSize?: number) => {
// 	return requestInstance
// 		.get(`/batch/getOnePage/${batchId}`, { pageNum, pageSize })
// 		.fire()
// }
/**
 * 修改自动裁剪任务执行后生成的图片
 */
export const updateBatchImage = (data: any) => {
	return requestInstance
		.upload(`/batch/updateImage`, data)
		.fire()
}
/**
 * 将图片同步到设计器
 */
export const uploadSynchronization = (data: any) => {
	return requestInstance
		.post(`/batch/synchronization`, data)
		.fire()
}
/**
 * 查询数据采集列表
 */
export const getGatherList = (data: any) => {
	return requestInstance
		.get('/product/info/list', data)
		.fire()
}
/**
 * 删除数据采集信息
 * @param id
 */
export const deleteGather = (id: string) => {
	return requestInstance
		.del<any, any>(`/product/info/${id}`, {})
		.fire()
}
/**
 * 批量删除数据采集信息
 * @param ids
 */
export const deleteGatherBatch = (ids: any) => {
	return requestInstance
		.del<any, any>(`/product/info/batch/${ids}`, {})
		.fire()
}
/**
 * 查询风险过滤列表
 */
export const getRiskFilterList = (data: any) => {
	return requestInstance
		.get('/risk/detection/task/list', data)
		.fire()
}
/**
 * 上传图片文件新建风险过滤任务
 */
export const createFilterByFiles = (data: any) => {
	return requestInstance
		.upload(`/risk/detection/task/createByImages`, data)
		.fire()
}
/**
 * 选择图片url新建风险过滤任务
 */
export const createByImageUrls = (data: any) => {
	return requestInstance
		.post('/risk/detection/task/createByImageUrls', data)
		.fire()
}
/* 
 *通过id创建风险过滤任务
 */
export const createByTaskIds = (data: any) => {
	return requestInstance
		.post('/risk/detection/task/createByImageIds', data)
		.fire()
}
/**
 * 选择商品id新建风险过滤任务
 */
export const createByProductIds = (data: any) => {
	return requestInstance
		.post('/risk/detection/task/createByProductIds', data)
		.fire()
}
/**
 * 获取侵权风险过滤详情
 * @param id
 */
export const getRiskFilterDetail = (data: any) => {
	return requestInstance
		.get(`/risk/detection/task/${data.id}`, data)
		.fire()
}
/**
 * 批量删除风险检测任务详情
 */
export const deleteRiskFilterDetail = (data: any) => {
	return requestInstance
		.del(`/risk/detection/task/detail/batch/${data.ids}`, {})
		.fire()
}
/**
 * 根据平台代码获取当前用户的账号信息
 * @param platformCode
 */
export const getPlatformInfo = (data: any) => {
	return requestInstance
		.get(`/front/platform-account/by-platform/${data.platformCode}`, data)
		.fire()
}
/**
 * 保存或更新用户第三方平台账号信息
 */
export const savePlatformAccount = (data: any) => {
	return requestInstance
		.post('/front/platform-account/save', data)
		.fire()
}
/**
 * 数据采集导出
 */
export const excelExport = (data: any) => {
	return requestInstance
		.downloadPost('/image/excelExport/export/products', data)
		.fire()
}
/**
 * 查询标题提取任务列表
 */
export const getTitleExtractionTaskList = (data: any) => {
	return requestInstance
		.get('/title/extraction/task/list', data)
		.fire()
}
/**
 * 通过图片文件创建标题提取任务
 */
export const createTitleExtractionTaskByImages = (data: any) => {
	return requestInstance
		.upload('/title/extraction/task/createByImages', data)
		.fire()
}
/**
 * 通过图片url创建标题提取任务
 */
export const createTitleExtractionTaskByImageUrls = (data: any) => {
	return requestInstance
		.post('/title/extraction/task/createByImageUrls', data)
		.fire()
}
/**
 * 通过图片ID创建标题提取任务
 */
export const createTitleExtractionTaskByProductIds = (data: any) => {
	return requestInstance
		.post('/title/extraction/task/createByImageIds', data)
		.fire()
}
/**
 * 获取标题提取详情
 * @param id
 */
export const getTitleExtractionTaskDetail = (data: any) => {
	return requestInstance
		.get(`/title/extraction/task/${data.id}`, { pageNum: data.pageNum, pageSize: data.pageSize })
		.fire()
}
/**
 * 查询香蕉Pro任务列表
 * TODO: replace with BananaPro endpoint.
 */
export const getBananaProTaskList = (data: any) => {
	return requestInstance
		.get('/title/extraction/task/list', data)
		.fire()
}
/**
 * 通过图片url创建香蕉Pro任务
 * TODO: replace with BananaPro endpoint.
 */
export const createBananaProTaskByImageUrls = (data: any) => {
	return requestInstance
		.post('/dialogue/task/batch-add', data)
		.fire()
}

/** 香蕉 Pro：通過表格文件創建批次任務（multipart） */
export const createBananaProTaskByExcel = (params: {
	file: File
	modelType: number
	model: string
	aspectRatio?: string
	resolution?: string
	imageNumber?: string
}) => {
	const data: Record<string, unknown> = {
		file: params.file,
		modelType: params.modelType,
		model: params.model,
	}
	if (params.aspectRatio != null && params.aspectRatio !== '') {
		data.aspectRatio = params.aspectRatio
	}
	if (params.resolution != null && params.resolution !== '') {
		data.resolution = params.resolution
	}
	if (params.imageNumber != null && params.imageNumber !== '') {
		data.imageNumber = params.imageNumber
	}
	return requestInstance.upload('/dialogue/task/batch-add-excel', data).fire()
}
/**
 * 获取香蕉Pro详情
 * TODO: replace with BananaPro endpoint.
 */
export const getBananaProTaskDetail = (data: any) => {
	return requestInstance
		.get(`/dialogue/task/getOnePage/list/detail`, {batchId:data.id, pageNum: data.pageNum, pageSize: data.pageSize })
		.fire()
}
/**
 * 获取工作流模板列表
 */
export const getWorkflowTemplateList = (data: any) => {
	return requestInstance
		.get('/workflow/template/list', data)
		.fire()
}
/**
 * 获取工作流列表
 */
export const getWorkflowList = (data: any) => {
	return requestInstance
		.get('/workflow/workflow/list', data)
		.fire()
}
/**
 * 查询工作流模板分组列表
 */
export const getTemplateGroupList = (data: any) => {
	return requestInstance
		.get('/workflow/templateGroup/list', data)
		.fire()
}
/**
 * 查询工作流公共模板列表
 */
export const getPublicList = (data: any) => {
	return requestInstance
		.get('/workflow/template/public/list', data)
		.fire()
}
/**
 * 新增工作流模板分组
 */
export const addTemplateGroup = (data: any) => {
	return requestInstance
		.post('/workflow/templateGroup', data)
		.fire()
}
/**
 * 修改工作流模板分组
 */
export const editTemplateGroup = (data: any) => {
	return requestInstance
		.put('/workflow/templateGroup', data)
		.fire()
}
/**
 * 删除工作流模板分组
 */
export const delTemplateGroup = (data: any) => {
	return requestInstance
		.del(`/workflow/templateGroup/${data.id}`, {})
		.fire()
}
/**
 * 新增工作流模板
 */
export const addWorkflowName = (data: any) => {
	return requestInstance
		.post('/workflow/template', data)
		.fire()
}
/**
 * 新增工作流模板（包含节点）
 */
export const addWorkflowTemplate = (data: any) => {
	return requestInstance
		.post('/workflow/template/withNodes', data)
		.fire()
}
/**
 * 复制工作流模板
 */
export const copyWorkflowTemplate = (data: any) => {
	return requestInstance
		.post(`/workflow/template/copy/${data.id}`, data)
		.fire()
}
/**
 * 获取工作流模板详细信息（包含节点）
 */
export const getWorkflowTemplateDetails = (data: any) => {
	return requestInstance
		.get(`/workflow/template/details/${data.templateId}`, {})
		.fire()
}
/* 审批工作流节点 */
export const approvalWorkflowNode = (data: any) => {
	return requestInstance
		.put('/workflow/workflow/is-manual-audit', data)
		.fire()
}
/**
 * 修改工作流模板名称/分组
 */
export const editTemplateInfo = (data: any) => {
	return requestInstance
		.put('/workflow/template', data)
		.fire()
}
/**
 * 更新模板节点
 */
export const editWorkflowTemplate = (data: any) => {
	return requestInstance
		.put(`/workflow/template/nodes/${data.id}`, data)
		.fire()
}
/**
 * 移动模板到指定分组
 */
export const moveWorkflowTemplate = (data: any) => {
	return requestInstance
		.put(`/workflow/template/move/${data.id}`, data)
		.fire()
}
/**
 * 删除工作流模板（包含节点）
 */
export const delWorkflowTemplate = (data: any) => {
	return requestInstance
		.del(`/workflow/template/delete/${data.id}`, {})
		.fire()
}
/**
 * 创建工作流（通过文件上传）
 */
export const createWorkflowByFiles = (data: any) => {
	return requestInstance
		.upload('/workflow/workflow/createByFiles', data)
		.fire()
}
/**
 * 创建工作流（通过URL地址列表）
 */
export const createWorkflowByUrls = (data: any) => {
	return requestInstance
		.post('/workflow/workflow/createByUrls', data)
		.fire()
}
/**
 * 创建工作流（通过图片ID列表）
 */
export const createWorkflowByImageIds = (data: any) => {
	return requestInstance
		.post('/workflow/workflow/createByIds', data)
		.fire()
}

/**
 * 查询商品模板分组列表
 */
export const getGoodsTemplateGroupList = (data: any) => {
	return requestInstance
		.get('/system/group/list', data)
		.fire()
}
/**
 * 导入商品模版列表查询
 */
export const getImportTemplateList = (data: any) => {
	return requestInstance
		.get('system/template/list', data)
		.fire()
}
/**
 * 解析excel文件system/template/uploadexcel
 */
export const parseExcelFile = (data: any) => {
	return requestInstance
		.upload('system/psrsing/uploadexcel', data)
		.fire()
}

/**
 * 新增商品模板分组
 */
export const addGoodsTemplateGroup = (data: any) => {
	return requestInstance
		.post('/system/group/add', data)
		.fire()
}
/**
 * 修改商品模板分组
 */
export const editGoodsTemplateGroup = (data: any) => {
	return requestInstance
		.put('/system/group/edit', data)
		.fire()
}
/**
 * 删除商品模板分组
 */
export const delGoodsTemplateGroup = (data: any) => {
	return requestInstance
		.del(`/system/group/${data.id}`, {})
		.fire()
}

/**
 * 获取商品模板列表
 */
// export const getGoodsTemplateList = (data: any) => {
// 	return requestInstance
// 		.get('/system/goodsTemplate/list', data)
// 		.fire()
// }

/**
 * 新增商品模板
 */
export const addGoodsTemplate = (data: any) => {
	return requestInstance
		.post('/system/template/added', data)
		.fire()
}

/**
 * 删除商品模板
 */
export const delGoodsTemplate = (data: any) => {
	return requestInstance
		.del(`/system/template/${data.id}`, {})
		.fire()
}

/**
 * 复制商品模板
 */
export const copyGoodsTemplate = (data: any) => {
	return requestInstance
		.post(`/system/template/copeexcelcustomtemplate/${data.id}`, {})
		.fire()
}

/**
 * 移动商品模板到指定分组
 */
export const moveGoodsTemplate = (data: any) => {
	return requestInstance
		.put(`/system/template/edit`, data)
		.fire()
}

/**
 * 获取商品模板详情
 */
export const getGoodsTemplateDetail = (data: any) => {
	return requestInstance
		.get(`/system/template/selectdetails/${data.id}`, {})
		.fire()
}
/**
 * 编辑商品模板
 */
export const editGoodsTemplate = (data: any) => {
	return requestInstance
		.put('/system/template/updatatExceltemplate', data)
		.fire()
}
/**
 * 商品模板导出
 */
export const goodsTemplateExportexcel = (data: any) => {
	return requestInstance
		.downloadPost('/system/template/exportexcel', data)
		.fire()
}

/* 备注查询 (采集 标题 侵权) */
export const getTaskRemark = (id: any) => {
	return requestInstance
		.get(`/title/extraction/task/${id}`, {})
		.fire()
}

/* 任务备注修改 */
export const updateTaskRemark = (data: any) => {
	return requestInstance
		.put('/batch/task/remark', data)
		.fire()
}
/**
 * 团队成员列表
 */
export const getTeamMembers = (data: any) => {
	return requestInstance
		.get('/front/team/members', data)
		.fire()
}
/**
 * 查询印花图品类
 */
export const getPrintingCategoryList = (data: any) => {
	return requestInstance.get('/cropExtractCategory/front/list', data).fire()
}
/**
 * 废弃图片接口
 */
export const abandonedImg = (data: any) => {
	return requestInstance.put('/workflow/approval/abandoned', data).fire()
}
/* 
 * 查询下载任务列表
 */
export const getDownloadTaskList = (data: any) => {
	return requestInstance
		.get(`/oss/file/zipTasks/?pageNum=${data.pageNum}&pageSize=10`, { id: data.id, memberId: data.memberId })
		.fire()
}
/* 
 * 创建下载任务
 */
export const createDownloadTask = (data: any) => {
	return requestInstance
		.post('/oss/file/batchZipAsync', data)
		.fire()
}
/* 创建模板导出任务  侵权 标题 采集*/
export const createTemplateExportTask = (data: any) => {
	return requestInstance
		.post('/system/template/exportexcelAsync', data)
		.fire()
}
/**
 * 手动终止工作流
 */
export const stopWorkflow = (id: number) => {
	return requestInstance
		.post<any, any>(`/workflow/workflow/cancel/${id}`, {})
		.fire()
}
/* 查询全局数据采集待处理数量 */
export const getGatherCount = () => {
	return requestInstance
		.get('/task/statistics/pending?type=prod', {})
		.fire()
}
/* 查询全局侵权风险待处理数量 */
export const getFilterCount = () => {
	return requestInstance
		.get('/task/statistics/pending?type=risk', {})
		.fire()
}
/* 查询全局标题提取待处理数量 */
export const gettitleCount = () => {
	return requestInstance
		.get('/task/statistics/pending?type=title', {})
		.fire()
}
/**
 * 查询香蕉Pro待处理数量
 * TODO: replace with BananaPro endpoint.
 */
export const getBananaProWaitingCount = () => {
	return requestInstance
		.get('/task/statistics/pending?type=title', {})
		.fire()
}
/* 违禁词列表查询 */
export const getProhibitedWords = (data: any) => {
	return requestInstance
		.get('/prohibitedWords/list', data)
		.fire()
}
/* 违禁词列表查询不分页 */
export const getProhibitedWordsAll = () => {
	return requestInstance
		.get('/prohibitedWords/listAll', {})
		.fire()
}
/* 新增违禁词 */
export const addProhibitedWords = (data: any) => {
	return requestInstance
		.post('/prohibitedWords', data)
		.fire()
}
/* 违禁词模版解析 */
export const parseProhibitedWords = (data: any) => {
	return requestInstance
		.upload('/prohibitedWords/parseTemplate', data)
		.fire()
}
/* 修改违禁词 */
export const editProhibitedWords = (data: any) => {
	return requestInstance
		.put('/prohibitedWords', data)
		.fire()
}
/* 删除违禁词 */
export const delProhibitedWords = (id: any) => {
	return requestInstance
		.del(`/prohibitedWords/${id}`, {})
		.fire()
}
/* 下载违禁词 */
export const downloadProhibitedWords = (id: any) => {
	return requestInstance
		.get(`/prohibitedWords/download/${id}`, {})
		.fire()
}
/* 获取插件下载地址 */
export const getPluginUrl = () => {
	return requestInstance
		.get('/plugin/version/download/product_info', {})
		.fire()
}
/* 工作流商品套图获取模板列表 */
export const getPhotosetTemplateList = (data: any) => {
	return requestInstance
		.get('/front/platform-api/forgediy/template-list', data)
		.fire()
}
/* 工作流商品套图获取模板de颜色列表 */
export const getPhotosetTemplateColorList = (id: any, colorId?: any) => {
	return requestInstance
		.get(`/front/platform-api/forgediy/designer-details?id=${id}&colorId=${colorId}`, {})
		.fire()
}
/* 商品套图获取模板的分类列表 */
export const getCategoryList = () => {
	return requestInstance
		.post(`/front/platform-api/forgediy/directory/select-all`, {})
		.fire()
}
/* 商品套图筛选模板 */
export const getTemplateList = (params: any) => {
	return requestInstance
		.post(`/front/platform-api/forgediy/template/client-select`, params)
		.fire()
}
/* 获取所有颜色列表套图第二版 1-14 弃用*/
export const getAllColorList = () => {
	return requestInstance
		.post(`/front/platform-api/forgediy/basis-color/list`, {})
		.fire()
}
/* 根据颜色获取模板列表 1-14 弃用 */
export const getTemplateCraftAndFactoryData = (params: any) => {
	return requestInstance
		.post(`/front/platform-api/forgediy/template/client-template-list-based-color`, params)
		.fire()
}
/* 根据分类获取颜色列表 1-31 弃用 */
export const getColorListByCategory = (params: any) => {
	return requestInstance
		.get(`/front/platform-api/basis-color/list?` + "catalogId=" + params, {})
		.fire()
}
/* 根据模板获取支持的颜色 */
export const getColorListByTemplate = (params: any) => {
	return requestInstance
		.get(`/front/platform-api/forgediy/template-color/get-by-template-id`, params)
		.fire()
}
/* 根据分类查模板 */
export const getTemplateDataByCategory = (params: any) => {
	return requestInstance
		.post(`/front/platform-api/forgediy/template/client-template-list-based`, params)
		.fire()
}
/* 查询模板宽高比 */
export const getTemplateRatio = (params: any) => {
	return requestInstance
		.get(`/front/platform-api/forgediy/mask/aspectRatios`, params)
		.fire()
}

/* 查询数据采集得颜色列表 */
export const getColorList = () => {
	return requestInstance
		.get(`product/info/colors`, {})
		.fire()
}
/* 删除上传图片详情内图片 */
export const delUploadImageDetail = (taskId: any) => {
	return requestInstance
		.del(`/batch/task/softDelete/` + taskId, {})
		.fire()
}

/* 单个任务前端获取实时扣分情况 */
export const calculateTaskScore = (data: any) => {
	return requestInstance
		.post('/admin/task-score-config/calculate', data)
		.fire()
}
/* 获取需要审核的数量 */
export const getNeedAuditCount = () => {
	return requestInstance
		.get(`/workflow/workflow/pendingApprovalCount`, {})
		.fire()
}
/* 查询语言列表(支持分页) */
export const getLanguageList = (params: any) => {
	return requestInstance
		.get('/language/list', params)
		.fire()
}
/* 查询规则列表  标题*/
export const getRuleList = (params: any) => {
	return requestInstance
		.get('/title/combination/rule/list', params)
		.fire()
}
/* 新增规则  标题*/
export const addCombinationRule = (data: any) => {
	return requestInstance
		.post('/title/combination/rule', data)
		.fire()
}
/* 修改规则  标题*/
export const editCombinationRule = (data: any) => {
	return requestInstance
		.put('/title/combination/rule', data)
		.fire()
}
/* 删除规则  标题*/
export const delCombinationRule = (ids: any) => {
	return requestInstance
		.del(`/title/combination/rule/${ids}`, {})
		.fire()
}
/* 复制规则  标题*/
export const copyCombinationRule = (id: any) => {
	return requestInstance
		.post(`/title/combination/rule/copy/${id}`, {})
		.fire()
}
/* 规则设为团队预设  标题*/
export const setTeamRule = (id: any) => {
	return requestInstance
		.put(`/title/combination/rule/setTeamPreset/${id}`, {})
		.fire()
}

/* 查询prompt列表 */
export const getPromptList = (params: any) => {
	return requestInstance
		.get('/title/extraction/prompt/template/list', params)
		.fire()
}
/* 新增prompt */
export const addExtractionPrompt = (data: any) => {
	return requestInstance
		.post('title/extraction/prompt/template', data)
		.fire()
}
/* 修改prompt */
export const editExtractionPrompt = (data: any) => {
	return requestInstance
		.put('/title/extraction/prompt/template', data)
		.fire()
}
/* 删除prompt */
export const delExtractionPrompt = (ids: any) => {
	return requestInstance
		.del(`/title/extraction/prompt/template/${ids}`, {})
		.fire()
}
/* 复制prompt */
export const copyExtractionPrompt = (id: any) => {
	return requestInstance
		.post(`/title/extraction/prompt/template/copy/${id}`, {})
		.fire()
}
/* prompt设为团队预设 */
export const setTeamPrompt = (id: any) => {
	return requestInstance
		.put(`/title/extraction/prompt/template/setTeamPreset/${id}`, {})
		.fire()
}

/** 预设指令分组：新增（defaultGroupType 1 个人 2 团队 3 官方） */
export const addDefaultPresetGroup = (data: { defaultGroupType: string | number; groupName: string,defaultTaskType?: string | number }) => {
	return requestInstance.post('/system/default/group/add', data).fire()
}

/** 预设指令分组：列表 */
export const getDefaultPresetGroupList = (params: { defaultGroupType?: string | number,defaultTaskType?: string | number }) => {
	return requestInstance.get('/system/default/group/list', params).fire()
}

/** 预设指令模板：创建（香蕉Pro） */
export const addBananaProPreset = (data: {
	defaultGroupId?: string | number;
	defaultTitle: string;
	presetInstructionType: string;
	presetInstruction: string;
	isPublic?: number;
	isTeamPreset?: number;
}) => {
	return requestInstance.post('/system/instruction/add', data).fire()
}

/** 香蕉Pro预设：列表 */
export const getBananaProPresetList = (params: {
	isPublic?: number;       // 是否官方预设(0-不是，1-是)
	isTeamPreset?: number;   // 我的预设/团队预设(0-我的，1-团队)
	defaultGroupId?: string | number;
}) => {
	return requestInstance.get('/system/instruction/list', params).fire()
}

/** 香蕉Pro预设：详情 */
export const getBananaProPresetDetail = (id: string | number) => {
	return requestInstance.get(`/system/instruction/${id}`, {}).fire()
}

/** 香蕉Pro预设：编辑 */
export const editBananaProPreset = (data: {
	id: string | number;
	defaultGroupId?: string | number;
	defaultTitle: string;
	presetInstruction: string;
}) => {
	return requestInstance.put('/system/instruction/edit', data).fire()
}

/** 香蕉Pro预设：拷贝和设为团队预设 */
export const copyBananaProPreset = (data: {
	id: string | number;
	defaultGroupId?: string | number;
}) => {
	return requestInstance.post('/system/instruction/cope_instruction', data).fire()
}

/** 香蕉Pro预设：删除 */
export const delBananaProPreset = (id: string | number) => {
	return requestInstance.del(`/system/instruction/${id}`, {}).fire()
}

/* 获取数据采集平台列表 */
export const getPlatforms = () => {
	return requestInstance
		.get('/product/info/platforms', {})
		.fire()
}
/* 修改违禁词是否用于采集过滤 */
export const updateBannedWord = (data: any) => {
	return requestInstance
		.put('/prohibitedWords/toggleFiltration', data)
		.fire()
}

/* 姿势智能填写 */
export const poseSmartFill = (data: any) => {
	return requestInstance
		.post('/dialogue/image/information/pose-smart-fill', data)
		.fire()
}
/* 姿势裂变生成结果 */
export const getPoseSplitTaskResult = (params: any) => {
	return requestInstance
		.get('/task/photo/getPoseSplitTaskResult', params)
		.fire()
}
/* 姿势裂变历史记录 */
export const getPoseSplitHistory = (params: any) => {
	return requestInstance
		.get('/task/photo/getPoseSplitHistory', params)
		.fire()
}
/* 获取模型/场景列表 */
export const getModelOrSceneList = (params: any) => {
	return requestInstance
		.get('/ai/model/template/list', params)
		.fire()
}
/* 查询所有一级标签列表 */
export const getTagTree = (params: any) => {
	return requestInstance
		.get('/ai/model/tag/tree', params)
		.fire()
}
/* 查询模特/场景收藏列表 */
export const getFavoriteList = (params: any) => {
	return requestInstance
		.get('/ai/model/template/favorite/list', params)
		.fire()
}
/* 模特/场景添加收藏 */
export const addFavorite = (params: any) => {
	return requestInstance
		.get(`/ai/model/template/favorite/add`, params)
		.fire()
}
/* 模特/场景取消收藏 */
export const removeFavorite = (params: any) => {
	return requestInstance
		.del(`/ai/model/template/favorite/remove/`, params)
		.fire()
}
/* 模特/场景使用记录 */
export const getUsageHistory = (params: any) => {
	return requestInstance
		.get('/ai/model/template/usage-history', params)
		.fire()
}
/* 新增我的模特/场景 */
export const createTemplate = (data: any) => {
	return requestInstance
		.post('/ai/model/template/create', data)
		.fire()
}
/* 删除我的模特/场景 */
export const delTemplate = (data: any) => {
	return requestInstance
		.post('/ai/model/template/delete-my', data)
		.fire()
}
/* 创建AI模特任务 */
export const creatAIModelTask = (data: any) => {
	return requestInstance
		.post('/dialogue/image/information/ai-model-change', data)
		.fire()
}
/* 创建商品换色任务 */
export const creatColorChangeTask = (data: any) => {
	return requestInstance
		.post('/dialogue/image/information/product-color-change', data)
		.fire()
}
/* 获取AI模特/商品换色生成结果*/
export const getAIModelTaskResult = (params: any) => {
	return requestInstance
		.get('/dialogue/task/getTaskResult', params)
		.fire()
}
/* 获取AI模特/商品换色历史任务*/
export const getAIModelHistory = (params: any) => {
	return requestInstance
		.get('/dialogue/task/getHistory', params)
		.fire()
}

/**
 * 查询正在运行/排队的批次列表
 */
export const getRunningBatches = () => {
	return requestInstance
		.get('/batch/getRunningBatches', {})
		.fire()
}
